import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

export default class RemoveMobilityCategoryModal extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <SettingRemoveModal
        setting={{ label: 'Wheelchair', id: 1 }}
        settingType='Mobility Category'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    console.log('remove')
  }

  private onClose = () => {
    this.props.history.push('/global-settings/mobility-category')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveMobilityCategoryModal.tsx